/* eslint-disable max-len */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import BaseSvgIcon from "./Base";
var More = function (props) { return (React.createElement(BaseSvgIcon, __assign({}, props, { viewBox: "0 0 14 4" }),
    React.createElement("g", { id: "Home-Page-v2.0-JM", stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
        React.createElement("g", { id: "Homepage_default_VD_Desktop-Copy-12", transform: "translate(-1113.000000, -858.000000)", fill: "#D8D8D8", stroke: "#3A3A38" },
            React.createElement("g", { id: "Group-12", transform: "translate(1114.000000, 859.000000)" },
                React.createElement("circle", { id: "Oval-6", cx: "1", cy: "1", r: "1" }),
                React.createElement("circle", { id: "Oval-6-Copy", cx: "6", cy: "1", r: "1" }),
                React.createElement("circle", { id: "Oval-6-Copy-2", cx: "11", cy: "1", r: "1" })))))); };
export default More;
